import { Modal, Text } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';

const { Header, Body, Footer } = Modal;

interface StatusFreeShippingModalProps {
  show: boolean;
  status: boolean;
  onClose: () => void;
  onChangeStatus: () => void;
}

export function StatusFreeShippingModal({
  show,
  status,
  onClose,
  onChangeStatus,
}: Readonly<StatusFreeShippingModalProps>) {
  const prefix = !status ? 'enable' : 'disable';
  const t = useTranslationMarketing(`freeShipping.statusModal.${prefix}`);
  const handleChangeStatus = () => {
    onChangeStatus();
    onClose();
  };

  return (
    <Modal open={show} onDismiss={onClose}>
      <Header title={t('title')} />
      <Body padding="none">
        <Text>{t('body')}</Text>
      </Body>
      <Footer>
        <CancelAndConfirmButtons
          onCancel={onClose}
          onConfirm={handleChangeStatus}
          cancelText={t('cancel')}
          confirmText={t('confirm')}
        />
      </Footer>
    </Modal>
  );
}
